import * as Yup from "yup";

export default Yup.object().shape({
    jobId: Yup.number().nullable(),
    jobTeamMemberIds: Yup.array().min(1, "Please select at least one Job Team Member"),
    jobLocationId: Yup.number().nullable().required("Please select a Job Location"),
    scheduleDate: Yup.array().nullable().min(1, "Please select Date"),
    startTime: Yup.array().nullable().min(1, "Please select a start time"),
    endTime: Yup.array().nullable().min(1, "Please select an end time"),
    additionalNotes: Yup.string().nullable(),
});

